module.exports = __webpack_public_path__ + "images/ranking-events-oos-d3e704c5.svg";